import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { UncontrolledTextInput } from '@src/components/Inputs'
import { SectionHeader } from '@src/components/ServicePopover/SectionHeader'
import { BottomSheet } from '@src/components/BottomSheet/BottomSheet'
import {
  MobileNavigationPopoverContentWrapper,
  MobileNavigationPopoverContent,
  MobileNavigationPopoverFooter,
  MobileNavigationPopoverFooterContent,
  MobileNavigationResetLink,
  DoneButton,
} from '@src/components/BottomSheet/BottomSheet.styles'
import { useBottomSheetStack } from '../../hooks/useBottomSheetStack/useBottomSheetStack'

export const PostcodePopover: React.FC<{
  onChange?: (postcode: string) => void
  onDone: (postcode: string) => void
  postcode?: string | null
  isPopover: boolean
}> = ({ onChange, onDone, postcode, isPopover }) => {
  const { postcodeBottomSheetController } = useBottomSheetStack()
  const { t } = useTranslation('serviceNavigation')
  const defaultPostcode = postcode || ''
  const [newPostcode, setNewPostcode] = useState(defaultPostcode)

  // if state is being managed by parent, update local state when parent state changes
  useEffect(() => {
    setNewPostcode(defaultPostcode)
  }, [defaultPostcode])

  const updatePostcode = onChange ? onChange : setNewPostcode

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = event => {
    if (event.key === 'Enter' && newPostcode) {
      onDone(newPostcode)
      postcodeBottomSheetController.close()
    }
  }

  const handleDismiss = () => {
    setNewPostcode(defaultPostcode)
    postcodeBottomSheetController.close()
  }

  return (
    <BottomSheet
      bottomSheetController={postcodeBottomSheetController}
      onDismiss={handleDismiss}
      maxWidth={584}
      showBackdrop={!isPopover}
    >
      <MobileNavigationPopoverContentWrapper>
        <MobileNavigationPopoverContent>
          <SectionHeader
            header={t('location_header')}
            subheader={t('find_location_postcode')}
          />
          <br />
          <UncontrolledTextInput
            label={t('enter_postcode')}
            name={'postcode'}
            maxLength={8}
            toUpperCase
            onChange={event => updatePostcode(event.target.value.toUpperCase())}
            value={newPostcode}
            touched={false}
            required={false}
            onKeyDown={handleKeyDown}
            dataTestId="service-postcodepopover-input-postcode"
          />
        </MobileNavigationPopoverContent>
      </MobileNavigationPopoverContentWrapper>
      <MobileNavigationPopoverFooter>
        <MobileNavigationPopoverFooterContent>
          <MobileNavigationResetLink onClick={handleDismiss}>
            {t('cancel')}
          </MobileNavigationResetLink>

          <DoneButton
            content={t('done')}
            width="180px"
            onClick={e => {
              e?.stopPropagation()
              newPostcode && onDone(newPostcode)
              postcodeBottomSheetController.close()
            }}
            type={'button'}
            disabled={!newPostcode}
            dataTestId="service-postcodepopover-button-done"
          />
        </MobileNavigationPopoverFooterContent>
      </MobileNavigationPopoverFooter>
    </BottomSheet>
  )
}
